import Communication from './Communication';
import Session from './Session';
import { PlanIds } from '../data/account';

/**
 * Contains utilities for Billing Plans
 */
class BillingPlans {
	static plans = [];

	static async init() {
		const response = await Communication.billingPlans();

		if (Communication.isSuccessful(response)) {
			const { data = {} } = response;
			this.plans = data.BillingPlans;

			for (const plan of this.plans) {
				plan.PlanId = this.getPlanId(plan.Sku);
			}
		}
	}

	static getPlanId(planSku) {
		return planSku - 1020000;
	}

	static getCurrentPlan() {
		const { planDetails = {} } = Session.getAccountInfo();

		const { planId } = planDetails;
		let currentPlan;

		this.plans.forEach(plan => {
			if (plan.PlanId === planId) {
				currentPlan = plan;
			}
		});
		return currentPlan;
	}

	static getPlanByPlanId(planId) {
		let plan;
		this.plans.forEach(record => {
			if (record.PlanId === planId) {
				plan = record;
			}
		});
		return plan;
	}

	// Gets the user's current active plan (either pending or current)
	// returns the active plan object
	static getCurrentActivePlan() {
		const { planDetails = {} } = Session.getAccountInfo();
		const { pendingPlanId: planSku } = planDetails;

		if (!planSku) {
			return this.getCurrentPlan();
		}

		const pendingPlanId = this.getPlanId(planSku);

		return this.getPlanByPlanId(pendingPlanId) || this.getCurrentPlan();
	}

	// Finds the next available upgrade plan based on price
	// returns the next higher-priced plan or null if none exists
	static getNextUpgradePlan = () => {
		const activePlan = this.getCurrentActivePlan();
		const sortedPlans = [...this.plans].sort((a, b) => a.Price - b.Price);

		return sortedPlans.find(plan => plan && activePlan.Price < plan.Price) || null;
	};

	static isUserInEcommercePlan = () => {
		const { planDetails = {} } = Session.getAccountInfo();
		const pendingPlanId = planDetails.pendingPlanId
			? planDetails.pendingPlanId - 1020000
			: null;

		return (
			planDetails.planId === PlanIds.Ecommerce ||
			planDetails.planId === PlanIds.EcommerceV383 ||
			pendingPlanId === PlanIds.Ecommerce ||
			pendingPlanId === PlanIds.EcommerceV383
		);
	};

	static isUserInCoreOfficeEssentialPlan = () => {
		const { planDetails = {} } = Session.getAccountInfo();

		return (
			planDetails.planId &&
			[
				PlanIds.Core,
				PlanIds.CoreV380,
				PlanIds.Office,
				PlanIds.OfficeV381,
				PlanIds.Essential,
			].indexOf(planDetails.planId) !== -1 &&
			!this.isUserInEcommercePlan()
		);
	};

	static isUserInPaygPlan = () => {
		const { planDetails = {} } = Session.getAccountInfo();
		return planDetails.planId === PlanIds.PAYG;
	};
}

export default BillingPlans;
